import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MessageDialogAction, MessageDialogData } from '../components/shared/message-dialog/message-dialog.model';
import { MessageDialogComponent } from '../components/shared/message-dialog/message-dialog';

@Injectable({ providedIn: 'root' })
export class MessageDialogService {
  constructor(private dialog: MatDialog) { }

  show(data: MessageDialogData) {
    return this.dialog.open(MessageDialogComponent, {
      width: data.width || '430px',
      maxWidth: '95vw',
      data
    }).afterClosed();
  }

  confirm(message: string, title = 'Confirm') {
    return this.show({ title, message, type: 'confirm', confirm: true });
  }

  choose(message: string, title = 'Choose', actions: MessageDialogAction[]) {
    return this.show({ title, message, type: 'confirm', actions });
  }

  info(message: string, title = 'Info') {
    return this.show({ title, message, type: 'info' });
  }

  error(message: string, title = 'Error') {
    return this.show({ title, message, type: 'error' });
  }

  success(message: string, title = 'Success') {
    return this.show({ title, message, type: 'success' });
  }

  warning(message: string, title = 'Warning') {
    return this.show({ title, message, type: 'warning' });
  }
}
